import {FC} from 'react';
import {Box, IconButton, Stack, Typography} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import {AdminBatchSubmission} from '../../../types/adminBatch.ts';

interface DefaultSubmissionTraceProps {
    submission: AdminBatchSubmission;
    prettyJson: (value?: unknown) => string;
    copyText: (key: string, text?: string) => void;
    copiedKey: string | null;
}

export const DefaultSubmissionTrace: FC<DefaultSubmissionTraceProps> = ({submission: s, prettyJson, copyText, copiedKey}) => {
    return (
        <Box sx={{p: 2, bgcolor: '#fafafa'}}>
            <Stack spacing={1.2}>
                <Typography variant="caption">
                    externalBatchId: <b>{s.externalBatchId || '-'}</b>
                </Typography>
                <details>
                    <summary style={{cursor: 'pointer', fontSize: 12, color: '#666'}}>원본 request/response JSON 보기</summary>
                    <Box sx={{mt: 1.2}}>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{mb: 0.5}}>request_json</Typography>
                        <Box sx={{display: 'flex', justifyContent: 'flex-end', mb: 0.5}}>
                            <IconButton size="small" onClick={() => copyText(`req-${s.id}`, prettyJson(s.requestJson))}>
                                {copiedKey === `req-${s.id}` ? <CheckIcon fontSize="small"/> : <ContentCopyIcon fontSize="small"/>}
                            </IconButton>
                        </Box>
                        <Box component="pre" sx={{p: 1, mb: 1.5, bgcolor: '#fff', border: '1px solid #eee', borderRadius: 1, overflowX: 'auto', fontSize: 12, maxHeight: 300}}>
                            {prettyJson(s.requestJson)}
                        </Box>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{mb: 0.5}}>response_json</Typography>
                        <Box sx={{display: 'flex', justifyContent: 'flex-end', mb: 0.5}}>
                            <IconButton size="small" onClick={() => copyText(`res-${s.id}`, prettyJson(s.responseJson))}>
                                {copiedKey === `res-${s.id}` ? <CheckIcon fontSize="small"/> : <ContentCopyIcon fontSize="small"/>}
                            </IconButton>
                        </Box>
                        <Box component="pre" sx={{p: 1, bgcolor: '#fff', border: '1px solid #eee', borderRadius: 1, overflowX: 'auto', fontSize: 12, maxHeight: 300}}>
                            {prettyJson(s.responseJson)}
                        </Box>
                    </Box>
                </details>
            </Stack>
        </Box>
    );
};
